import type { NotificationPreferencesData } from "./hooks/useNotificationPreferences";

/**
 * Notification preferences exposed as working controls in the Profile
 * settings panel. Every field here is persisted and has an active delivery
 * producer, so the overview summary always reflects real choices.
 */
export const SUPPORTED_NOTIFICATION_PREFERENCE_FIELDS = [
  "appointmentsEnabled",
  "medicationsEnabled",
  "cycleUpdates",
  "testResults",
  "coverageStatus",
  "documentsEnabled",
] as const;

export type SupportedNotificationPreferenceField =
  (typeof SUPPORTED_NOTIFICATION_PREFERENCE_FIELDS)[number];

/**
 * Resolve preference values at runtime so a deployed dashboard field can be
 * surfaced without modifying generated API source. The generated contract is
 * refreshed separately through `pnpm generate:api`.
 */
export function isNotificationPreferenceEnabled(
  preferences: NotificationPreferencesData,
  field: SupportedNotificationPreferenceField,
): boolean {
  return Reflect.get(preferences, field) === true;
}

export function countSupportedNotificationPreferences(
  preferences: NotificationPreferencesData | null | undefined,
): number | null {
  if (!preferences) return null;

  return SUPPORTED_NOTIFICATION_PREFERENCE_FIELDS.filter((field) =>
    isNotificationPreferenceEnabled(preferences, field),
  ).length;
}
